// src/components/SubscribeButton.jsx
import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { PLANS, isPlanEnabled, isComingSoon } from "../config/payments";
import { RAZORPAY } from "../config/payments";

export default function SubscribeButton({
  plan = PLANS.WEEK_PASS,
  email = "",
  name = "",
  className = "",
  children,
}) {
  const location = useLocation();

  const apiBase =
    typeof window !== "undefined" &&
    window.location.hostname === "localhost" &&
    window.location.port === "3001"
      ? "http://localhost:3000"
      : "";

  const handleSubscribe = useCallback(async () => {
    try {
      if (isComingSoon(plan)) return;
      if (!plan?.id || !plan?.amount) {
        alert("Plan is not configured.");
        return;
      }
      if (!isPlanEnabled(plan)) {
        alert("This plan is no longer available.");
        return;
      }

      const params = new URLSearchParams(location.search);
      const back = params.get("back") || "/chapter-4";

      const r = await fetch(`${apiBase}/api/create-payment-link`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          planId: plan.id,
          amount: plan.amount,
          currency: plan.currency || "INR",
          tenureDays: plan.tenureDays,
          email,
          name,
          back,
        }),
      });

      const ct = r.headers.get("content-type") || "";
      if (!ct.includes("application/json")) {
        const fallback = plan.linkKey && RAZORPAY.paymentLinks[plan.linkKey];
        if (fallback) {
          console.warn("API returned HTML (dev not running). Using direct link fallback.");
          window.location.href = fallback;
          return;
        }
        await r.text(); // discard body to avoid ESLint 'no-unused-vars'
        throw new Error("Payment API is not available. Start it with `npx vercel dev`.");
      }

      const data = await r.json();
      if (!r.ok) {
        console.error("Create link failed:", data);
        alert(data?.error || "Could not start payment.");
        return;
      }

      window.location.href = data.url;
    } catch (e) {
      console.error(e);
      alert(e.message || "Something went wrong.");
    }
  }, [plan, email, name, location.search, apiBase]);

  const label =
    children ||
    (isComingSoon(plan)
      ? plan.displayLabel || "Monthly — Coming Soon"
      : `Get ${plan?.description?.split(" — ")[1] || plan?.id}`);

  const isDisabled = isComingSoon(plan) || !isPlanEnabled(plan);

  return (
    <button
      type="button"
      onClick={handleSubscribe}
      className={
        className ||
        `px-5 py-3 rounded-xl font-semibold ${
          isDisabled
            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
            : "bg-indigo-600 text-white hover:bg-indigo-700"
        }`
      }
      disabled={isDisabled}
      aria-disabled={isDisabled}
      style={isDisabled ? { pointerEvents: "none" } : undefined}
    >
      {label}
    </button>
  );
}
